import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star, Users, Calendar, Heart } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Nunca imaginé que el photo booth iba a ser lo que más le gustó a todos. Mi suegra no quería irse sin tomarse otra foto con la novia. Fue la mejor decisión que tomamos para la boda.',
    author: 'Familia González',
    location: 'Atlanta GA'
  }, {
    quote: 'Para la quinceañera de mi hija quería algo diferente, algo elegante. El espejo fue perfecto. Cada invitado se fue con su foto y todos me preguntaron dónde lo conseguí.',
    author: 'Mamá orgullosa',
    location: 'Norcross GA'
  }, {
    quote: 'Lo que más me gustó fue que mi abuela — que tiene 82 años y vino de México — se pudo tomar una foto conmigo y llevársela en la mano. Eso no tiene precio.',
    author: 'Novia feliz',
    location: 'Marietta GA'
  }];
  const stats = [{
    icon: <Calendar className="w-6 h-6 text-gold" data-id="element-495" />,
    text: 'Cientos de eventos celebrados'
  }, {
    icon: <Users className="w-6 h-6 text-gold" data-id="element-496" />,
    text: 'Miles de familias hispanas atendidas'
  }, {
    icon: <Heart className="w-6 h-6 text-gold" data-id="element-497" />,
    text: 'Un solo compromiso: hacer cada momento eterno'
  }];
  return <section id="testimonios" className="py-20 md:py-28 bg-cream relative" data-id="element-498">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl" data-id="element-499">
        <div className="text-center mb-16" data-id="element-500">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-charcoal mb-4" data-id="element-501">
            Historias de nuestras familias
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-502"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-503">
          {testimonials.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-white rounded-2xl p-8 shadow-xl border border-gold/10 relative" data-id="element-504">
              <Quote className="absolute top-6 right-6 w-10 h-10 text-gold/20" data-id="element-505" />
              <div className="flex gap-1 mb-6" data-id="element-506">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-gold fill-gold" data-id="element-507" />)}
              </div>
              <p className="font-serif text-lg italic text-charcoal/80 mb-8 leading-relaxed" data-id="element-508">
                "{item.quote}"
              </p>
              <div className="mt-auto" data-id="element-509">
                <p className="font-bold text-charcoal" data-id="element-510">{item.author}</p>
                <p className="text-sm text-charcoal/60" data-id="element-511">{item.location}</p>
              </div>
            </motion.div>)}
        </div>

        {/* Stats Row */}
        <div className="bg-charcoal rounded-2xl p-8 shadow-2xl border border-gold/20" data-id="element-512">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 divide-y md:divide-y-0 md:divide-x divide-gold/20" data-id="element-513">
            {stats.map((stat, index) => <div key={index} className="flex flex-col items-center text-center pt-6 md:pt-0 px-4 first:pt-0" data-id="element-514">
                <div className="bg-gold/10 p-4 rounded-full mb-4" data-id="element-515">
                  {stat.icon}
                </div>
                <p className="text-cream font-medium text-lg" data-id="element-516">{stat.text}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}